/** A.5 — View-only voice monitor. Reject non-verified reply candidates. */
export function readableOwnerReplies(ownerGroup) {
 if(!ownerGroup?.configured || !Array.isArray(ownerGroup.assistantMessages))return [];
 const unique=new Set();
 return ownerGroup.assistantMessages.filter(r=>{
   if(typeof r?.id!=='string'||!r.id||unique.has(r.id))return false;
   if(r.evidence!=='PROVIDER_ACCEPTED'||typeof r.text!=='string'||!r.text.trim())return false;
   if(!Number.isFinite(new Date(r.at).getTime()))return false;
   unique.add(r.id);return true;
 }).sort((a,b)=>Date.parse(a.at)-Date.parse(b.at)||a.id.localeCompare(b.id)).slice(-40);
}
export function newOwnerSignals(previous,current,{initialized=false}={}) {
 const currentIds=new Set((current||[]).map(x=>x?.id).filter(Boolean));
 if(!initialized)return {newItems:[],ids:currentIds};
 return {newItems:(current||[]).filter(x=>x?.id&&!previous.has(x.id)),ids:currentIds};
}
export function safeOwnerSpeech(text) {
 // Text content only, no SSML, URLs or codes: avoid speaking giant financial tables.
 return String(text||'').replace(/^\s*🤖\s*Owner\s*:\s*/iu,'').replace(/https?:\/\/\S+/gu,' enlace ').replace(/\s+/gu,' ').trim().slice(0,1350);
}
